import { Box, Stack, styled, Typography } from '@mui/material';

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.colorBrand?.primary,
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'flex-start',
  cursor: 'pointer',
  '&:hover': {
    '& .MuiTypography-root': theme.mixins.hoverTextLightBlue,
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    justifyContent: 'space-between',
  },
}));
export const StyledIcon = styled(`img`)(({ theme }) => ({
  transform: 'rotate(-90deg)',
  opacity: 0,
  position: 'absolute',
  [theme.breakpoints.up('md')]: {
    marginLeft: theme.spacing(1),
  },
}));
export const StyledIconWrapper = styled(Box)(() => ({
  position: 'relative',
  width: '10px',
  height: '7px !important',
}));
